import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core";
import BotonGenerico from "../Button/Button";

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirmar acción",
  description = "¿Está seguro que desea continuar?",
  confirmText = "Aceptar",
  cancelText = "Cancelar",
  icon = null,
  classes = {},
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle className={classes.dialogTitle}>
        {icon && <span className={classes.iconWrapper}>{icon}</span>}
        <Typography variant="h6" component="span" gutterBottom>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography>{description}</Typography>
      </DialogContent>
      <DialogActions className={classes.dialogButtons}>
        <BotonGenerico
          tipo="guardar"
          text={confirmText}
          onClick={onConfirm}
          color="primary"
        />
        <BotonGenerico
          tipo="cancelar"
          text={cancelText}
          onClick={onClose}
          color="secondary"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
